<div class="my-documents-container">
    <div class="d-flex justify-content-between">
        <div>
            <h2 class="widget-header h4" i18n="my documents header@@my-documents-header">Your documents</h2>
            <h3 class="text-muted h6" i18n="my documents sub title@@my-documents-sub-title">
                Here you'll find your recent documents and documents that are trending among your colleagues. Use the button to upload, or drag and drop a document to this area to upload it to your OneDrive.
            </h3>
        </div>
        <div *ngIf="onedriveLink$ | async as onedriveLink" class="d-none d-sm-block">
            <app-upload-document-button [onedriveLink]="onedriveLink"></app-upload-document-button>
        </div>
    </div>

    <!--Drag and Drop -->
    <div class="mt-4">
        <ngx-file-drop dropZoneClassName="file-drop" contentClassName="content" (onFileDrop)="dropped($event)">
            <!--documents tabs section -->
            <ng-template ngx-file-drop-content-tmp>
                <div class="row">
                    <div class="col-12">

                        <!-- Table Headers -->
                        <mat-tab-group role="tablist" class="widget-tab-group" (selectedTabChange)="handleChange($event)" [(selectedIndex)]="selectedIndex">
                            <mat-tab role="tab">
                                <ng-template mat-tab-label>
                                    <span id="table_recent" i18n="my docments tab recent@@my-documents-tab-recent" class="mr-4">Recent</span>
                                </ng-template>
                            </mat-tab>
                            <mat-tab role="tab">
                                <ng-template mat-tab-label>
                                    <span id="table_trending" i18n="my documents tab trending@@my-documents-tab-trending" class="mr-4">Trending</span>
                                </ng-template>
                            </mat-tab>
                            <mat-tab role="tab">
                                <ng-template mat-tab-label>
                                    <span id="table_shared" i18n="my documents tab shared@@my-documents-tab-shared" class="">Shared</span>
                                </ng-template>
                            </mat-tab>
                        </mat-tab-group>

                        <!-- Recent -->
                        <section *ngIf="selectedIndex === 0" class="">
                            <div *ngIf="myRecentDocuments$ | async as myRecentDocuments; else loading">
                                <div *ngIf="myRecentDocuments.length === 0; else recentDocumentsTemplate">
                                    <app-text-placeholder>
                                        <p i18n="no recent documents@@no-recent-documents">No documents were found.</p>
                                    </app-text-placeholder>
                                </div>
                                <ng-template #recentDocumentsTemplate>
                                    <mat-table aria-label="Recent documents" i18n-aria-label="@@recent-documents" aria-describedby="table_recent" [dataSource]="myRecentDocuments|slice:0:showMore" #matTable>
                                        <!-- Title Column -->
                                        <ng-container matColumnDef="title">
                                            <mat-header-cell *matHeaderCellDef>
                                                <i class="ms-Icon ms-Icon--Page text-center mr-4 file-icon-header" aria-hidden="true"></i>
                                                <span i18n="my documents column title@@my-documents-col-title" class="text-muted">Title</span>
                                            </mat-header-cell>
                                            <mat-cell *matCellDef="let document">
                                                <span class="mr-4">
                                                    <i class="text-center file-icon {{document.IconClasses}}" aria-hidden="true"></i>
                                                </span>
                                                <span data-hj-suppress>
                                                    <a class="d-block" href="{{document.Path}}">{{document.Title}}</a>
                                                    <a class="d-block text-muted small" href="{{document.ContainerUrl}}">{{getUrlAsBreadCrumbs(document.ContainerUrl)}}</a>
                                                </span>
                                            </mat-cell>
                                        </ng-container>

                                        <!-- Activity Column -->
                                        <ng-container matColumnDef="activity">
                                            <mat-header-cell *matHeaderCellDef class="d-none d-md-flex">
                                                <span i18n="my documents column activity@@my-documents-col-activity" class="text-muted">Activity</span>
                                            </mat-header-cell>
                                            <mat-cell *matCellDef="let document" class="d-none d-md-flex">
                                                <span *ngIf="document.EdgeAction === 1">
                                                    <span i18n="viewed by you@@viewed-by-you" class="mr-1">Viewed by you</span>
                                                    <ng-container *ngIf="document.LastModified">{{document.EdgeDate| date:'mediumDate'}}</ng-container>
                                                </span>
                                                <span *ngIf="document.EdgeAction === 2">
                                                    <span i18n="edited by you@@edited-by-you" class="mr-1">Edited by you</span>
                                                    <ng-container *ngIf="document.LastModified">{{document.LastModified| date:'mediumDate'}}</ng-container>
                                                </span>
                                            </mat-cell>
                                        </ng-container>

                                        <mat-header-row *matHeaderRowDef="['title', 'activity']"></mat-header-row>
                                        <mat-row *matRowDef="let row; columns: ['title', 'activity'];" class="pb-3 pt-3"></mat-row>
                                    </mat-table>
                                </ng-template>
                                <div class="mt-4 float-left" *ngIf="myRecentDocuments">
                                    <app-action-button (clickEvent)="toggleShowMore()" *ngIf="myRecentDocuments.length > minDocuments">
                                        <span *ngIf="showMore === minDocuments" i18n="show more text@@show-more">Show more</span>
                                        <i *ngIf="showMore === minDocuments" class="ml-2 ms-Icon ms-Icon--ChevronDown align-bottom" aria-hidden="true"></i>
                                        <span *ngIf="showMore === maxDocuments" i18n="show less text@@show-less">Show less</span>
                                        <i *ngIf="showMore === maxDocuments" class="ml-2 ms-Icon ms-Icon--ChevronUp align-bottom" aria-hidden="true"></i>
                                    </app-action-button>
                                </div>
                            </div>
                        </section>

                        <!-- Trending -->
                        <section *ngIf="selectedIndex === 1" class="">
                            <div *ngIf="myTrendingDocuments$ | async as myTrendingDocuments; else loading" class="">
                                <div *ngIf="myTrendingDocuments.length === 0; else trendingDocumentsTemplate">
                                    <app-text-placeholder>
                                        <p i18n="no trending documents@@no-trending-documents">No documents were found.</p>
                                    </app-text-placeholder>
                                </div>
                                <ng-template #trendingDocumentsTemplate>
                                    <mat-table aria-label="Trending documents" i18n-aria-label="@@trending-documents" aria-describedby="table_trending" [dataSource]="myTrendingDocuments|slice:0:showMore" #matTable>
                                        <!-- Title Column -->
                                        <ng-container matColumnDef="title">
                                            <mat-header-cell *matHeaderCellDef>
                                                <i class="ms-Icon ms-Icon--Page text-center mr-4 file-icon-header" aria-hidden="true"></i>
                                                <span i18n="my documents column title@@my-documents-col-title" class="text-muted">Title</span>
                                            </mat-header-cell>
                                            <mat-cell *matCellDef="let document">
                                                <span class="mr-4">
                                                    <i class="text-center file-icon {{document.IconClasses}}" aria-hidden="true"></i>
                                                </span>
                                                <span>
                                                    <a class="d-block" href="{{document.Path}}">{{document.Title}}</a>
                                                    <a class="d-block text-muted small" href="{{document.ContainerUrl}}">{{getUrlAsBreadCrumbs(document.ContainerUrl)}}</a>
                                                </span>
                                            </mat-cell>
                                        </ng-container>

                                        <mat-header-row *matHeaderRowDef="['title']"></mat-header-row>
                                        <mat-row *matRowDef="let row; columns: ['title'];" class="pb-3 pt-3"></mat-row>
                                    </mat-table>
                                </ng-template>
                                <div class="mt-4 float-left" *ngIf="myTrendingDocuments">
                                    <app-action-button (clickEvent)="toggleShowMore()" *ngIf="myTrendingDocuments.length > minDocuments">
                                        <span *ngIf="showMore === minDocuments" i18n="show more text@@show-more">Show more</span>
                                        <i *ngIf="showMore === minDocuments" class="ml-2 ms-Icon ms-Icon--ChevronDown align-bottom" aria-hidden="true"></i>
                                        <span *ngIf="showMore === maxDocuments" i18n="show less text@@show-less">Show less</span>
                                        <i *ngIf="showMore === maxDocuments" class="ml-2 ms-Icon ms-Icon--ChevronUp align-bottom" aria-hidden="true"></i>
                                    </app-action-button>
                                </div>

                            </div>
                        </section>

                        <!-- Shared -->
                        <section *ngIf="selectedIndex === 2" class="">
                            <div *ngIf="mySharedResult$ | async as mySharedResult; else loading" class="">
                                <div *ngIf="mySharedResult.length === 0; else sharedDocumentsTemplate">
                                    <app-text-placeholder>
                                        <p i18n="no shared result@@no-shared-result">No documents were found.</p>
                                    </app-text-placeholder>
                                </div>
                                <ng-template #sharedDocumentsTemplate>
                                    <mat-table aria-label="Shared documents" i18n-aria-label="@@shared-documents" aria-describedby="table_shared" [dataSource]="mySharedResult|slice:0:showMore" #matTable>
                                        <!-- Title Column -->
                                        <ng-container matColumnDef="title">
                                            <mat-header-cell *matHeaderCellDef>
                                                <i class="ms-Icon ms-Icon--Page text-center mr-4 file-icon-header" aria-hidden="true"></i>
                                                <span i18n="my documents column title@@my-documents-col-title" class="text-muted">Title</span>
                                            </mat-header-cell>
                                            <mat-cell *matCellDef="let document">
                                                <span class="mr-4">
                                                    <i class="text-center file-icon {{document.IconClasses}}" aria-hidden="true"></i>
                                                </span>
                                                <span>
                                                    <a class="d-block" href="{{document.Path}}">{{document.Title}}</a>
                                                    <a class="d-block text-muted small" href="{{document.ContainerUrl}}">{{getUrlAsBreadCrumbs(document.ContainerUrl)}}</a>
                                                </span>
                                            </mat-cell>
                                        </ng-container>

                                        <mat-header-row *matHeaderRowDef="['title']"></mat-header-row>
                                        <mat-row *matRowDef="let row; columns: ['title'];" class="pb-3 pt-3"></mat-row>
                                    </mat-table>
                                </ng-template>
                                <div class="mt-4 float-left" *ngIf="mySharedResult">
                                    <app-action-button (clickEvent)="toggleShowMore()" *ngIf="mySharedResult.length > minDocuments">
                                        <span *ngIf="showMore === minDocuments" i18n="show more text@@show-more">Show more</span>
                                        <i *ngIf="showMore === minDocuments" class="ml-2 ms-Icon ms-Icon--ChevronDown align-bottom" aria-hidden="true"></i>
                                        <span *ngIf="showMore === maxDocuments" i18n="show less text@@show-less">Show less</span>
                                        <i *ngIf="showMore === maxDocuments" class="ml-2 ms-Icon ms-Icon--ChevronUp align-bottom" aria-hidden="true"></i>
                                    </app-action-button>
                                </div>
                            </div>
                        </section>

                        <div class="float-right mt-4" *ngIf="onedriveLink$ | async as onedriveLink">
                            <app-action-link [href]="onedriveLink" [target]="'_blank'">
                                <span i18n="all documents@@all-documents">Go to OneDrive</span><i class="ml-2 ms-Icon ms-Icon--ArrowUpRight" aria-hidden="true"></i>
                            </app-action-link>
                        </div>
                        <div class="text-center text-muted small mt-4" *ngIf="!isMobileDevice">
                            <p i18n="drag file@@drag-file">Drag a file here to upload and open</p>
                        </div>
                    </div>
                </div>
            </ng-template>

        </ngx-file-drop>
    </div>

    <ng-template #loading>
        <div class="mt-4">
            <div *ngIf="errorSubject$ | async as err; else innerLoading">
                <app-error-templates [error]="err.status" [componentName]="componentName"></app-error-templates>
            </div>
            <ng-template #innerLoading>
                <app-widget-placeholder></app-widget-placeholder>
            </ng-template>
        </div>
    </ng-template>

</div>
